import styled from 'styled-components';

import { LANDING_BREAKPOINT } from '@utils/theme/breakPoint';

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.lynxWhite};
  color: ${({ theme }) => theme.palette.brownishGrey};
  display: flex;
  flex-direction: column;
  padding: 20px 15px;
  font-size: 16px;

  @media (min-width: ${LANDING_BREAKPOINT}) {
    padding: 20px calc((100% - ${LANDING_BREAKPOINT}) / 2);
    justify-content: center;

    line-height: 1.31;
    padding-bottom: 50px;
  }
`;

export const SeoTextTitle = styled.div`
  color: ${({ theme }) => theme.palette.darkGray};
  font-weight: bold;
  font-size: 18px;
  padding-bottom: 19px;
  @media (min-width: ${LANDING_BREAKPOINT}) {
    font-size: 24px;
    padding-bottom: 28px;
  }
`;

export const ReadMore = styled.div`
  justify-content: center;
  display: flex;
`;
export const Cursor = styled.div`
  cursor: pointer;
`;
export const Div = styled.div`
  position: relative;
  max-height: 170px;
  overflow: hidden;
  transition-property: all;
  transition-duration: 0.5s;
  transition-timing-function: cubic-bezier(0.45, 0.45, 0.48, 0.93);
  & h1,
  h2,
  h3,
  h4,
  h5 {
    margin-bottom: 0px;
    margin-top: 20px;
  }
  & ol,
  ul {
    margin-top: 10px;
  }
  & h3,
  h4,
  h5 {
    font-size: 16px;
    font-weight: 700;
  }
  & h1,
  h2 {
    font-size: 18px;
    font-weight: 700;
  }
  & p {
    font-size: 14px;
  }
`;
export const DivComplate = styled.div`
  position: relative;
  max-height: 100%;
  overflow: hidden;
  transition-property: all;
  transition-duration: 0.5s;
  transition-timing-function: cubic-bezier(0.45, 0.45, 0.48, 0.93);
  & h1,
  h2,
  h3,
  h4,
  h5 {
    margin-bottom: 0px;
    margin-top: 20px;
  }
  & ol,
  ul {
    margin-top: 10px;
  }
  & h3,
  h4,
  h5 {
    font-size: 16px;
    font-weight: 700;
  }
  & h1,
  h2 {
    font-size: 18px;
    font-weight: 700;
  }
  & p {
    font-size: 14px;
  }
`;
export const Degree = styled.div`
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  z-index: 99;
  background: 0 0;
  background: -moz-linear-gradient(
    top,
    rgba(247, 247, 247, 0) 0%,
    rgba(247, 247, 247, 0.53) 50%,
    rgba(247, 247, 247, 0.83) 82%,
    #fff 100%
  );

  background: linear-gradient(
    to bottom,
    rgba(247, 247, 247, 0) 0%,
    rgba(247, 247, 247, 0.53) 50%,
    rgba(247, 247, 247, 0.83) 82%,
    #f7f7f7 100%
  );
`;

export const WrapperHomePage = styled.div`
  color: ${({ theme }) => theme.palette.brownishGrey};
  display: flex;
  flex-direction: column;
  padding: 0px 15px 23px 15px;
  font-size: 16px;

  @media (min-width: ${LANDING_BREAKPOINT}) {
    padding: 0px calc((100% - ${LANDING_BREAKPOINT}) / 2);
    justify-content: center;

    line-height: 1.31;
    padding-bottom: 20px;
  }
`;

export const SeoTextHomePageTitle = styled.div`
  color: ${({ theme }) => theme.palette.darkGray};
  font-weight: bold;
  font-size: 18px;
  padding-bottom: 19px;
  @media (min-width: ${LANDING_BREAKPOINT}) {
    font-size: 24px;
    padding-bottom: 28px;
  }
`;

export const HomePageReadMore = styled.div`
  margin-top: 10px;
  justify-content: flex-end;
  display: flex;
  position: relative;
  z-index: 1;
`;
export const HomePageCursor = styled.div`
  cursor: pointer;
  color: ${({ theme }) => theme.palette.burntSienna};
  font-size: 18px;
  font-weight: 600;
`;
export const HomePageDiv = styled.div`
  position: relative;
  max-height: 170px;
  overflow: hidden;
  transition-property: all;
  transition-duration: 0.5s;
  transition-timing-function: cubic-bezier(0.45, 0.45, 0.48, 0.93);
`;
export const HomePageDivComplate = styled.div`
  position: relative;
  max-height: 100%;
  overflow: hidden;
  transition-property: all;
  transition-duration: 0.5s;
  transition-timing-function: cubic-bezier(0.45, 0.45, 0.48, 0.93);
`;
